<div
  class="main-container outer-wrap"
  [ngClass]="brand === 'VIVUS' ? 'vivus-style' : ''"
>
  <div class="main-container inner-wrap">
    <div class="field-wrap">
      <h4>Правила взаимодействия с компанией</h4>
    </div>
    <div class="field-wrap">
      <a
        href="/docs/informacija_dlja_klienta_jet.pdf"
        target="_blank"
        (click)="
          analyticService.readDoc(
            'согласие с правилами Предоставления и обслуживания микрозаймов'
          )
        "
        >Правила предоставления и обслуживания микрозаймов
      </a>
    </div>
    <div class="field-wrap">
      <a
        href="/docs/obshhie_uslovija_dogovora_potrebitel_zajma_jet.pdf"
        target="_blank"
        (click)="
          analyticService.readDoc(
            'Общие условия договора потребительского микрозайма'
          )
        "
        >Общие условия договора потребительского микрозайма
      </a>
    </div>
    <div class="field-wrap">
      <a
        [href]="rulesList.acceptanceOfServices"
        target="_blank"
        (click)="analyticService.readDoc('Договором принятия на обслуживание')"
        >Договор принятия на обслуживание
      </a>
    </div>
    <div class="field-wrap">
      <span>
        <a
          href="/docs/soglasie_na_obrabotku_pers_dannyh_v3_jet.pdf"
          target="_blank"
          (click)="
            analyticService.readDoc('согласие на обработку персональных данных')
          "
          >Согласие на обработку персональных данных
        </a>
      </span>
    </div>
    <div class="field-wrap">
      <a
        [href]="rulesList.siteUsageRules"
        target="_blank"
        (click)="analyticService.readDoc('правила пользования сайтами')"
        >Правила пользования сайтами
      </a>
    </div>
    <div class="field-wrap">
      <a
        [href]="rulesList.disclosureOfCreditHistory"
        target="_blank"
        (click)="
          analyticService.readDoc(
            'согласие на раскрытие информации, содержащейся в основной части кредитной истории'
          )
        "
        >Согласие на раскрытие информации, содержащейся в основной части
        кредитной истории
      </a>
    </div>
    <div class="field-wrap">
      <a
        href="/docs/soglashenie_ob_ispolzovanii_ASP_v3_jet.pdf"
        target="_blank"
        (click)="analyticService.readDoc('Соглашение об использовании АСП')"
        >Соглашение об использовании аналога собственноручной подписи
      </a>
    </div>
    <div class="field-wrap">
      <a
        [href]="rulesList.getInformation"
        target="_blank"
        (click)="analyticService.readDoc('согласие на получение информации')"
        >Согласие на получение информации</a
      >
    </div>
    <div class="field-wrap">
      <span>
        Условия акции.
        <a [href]="discontTerms.link" target="_blank">Для первых займов.</a>
        <a [href]="rulesList.stockTermsGraceInTimeCheaper" target="_blank">
          Для повторных займов</a
        >
      </span>
    </div>
    <div class="field-wrap">
      <span>
        <a href="/docs/equifax_agreement.pdf" target="_blank"
          >Согласие на обработку персональных данных посетителя сайта</a
        >
      </span>
    </div>
    <div class="field-wrap">
      <span>
        <a href="https://money.yandex.ru/pay/page?id=526623" target="_blank"
          >Согласие с офертой Яндекс.Касса</a
        >
      </span>
    </div>
    <div class="field-wrap">
      <h5>Подтверждаю соответствие всем приведенным условиям:</h5>
      <span
        >Не являюсь участником судебных дел о банкротстве сроком давности менее
        5 лет</span
      >
      <span
        >Не являюсь
        <a
          routerLink="/agreements"
          target="_blank"
          (click)="
            analyticService.readDoc(
              'Не являюсь должностным лицом иностранного государства'
            )
          "
          >должностным лицом иностранного государства</a
        ></span
      >
      <span
        >Не являюсь
        <a
          routerLink="/agreements"
          target="_blank"
          (click)="
            analyticService.readDoc(
              'Не являюсь должностным лицом международной организации'
            )
          "
          >должностным лицом международной организации</a
        ></span
      >
      <span
        >Не являюсь близким родственником
        <a
          routerLink="/agreements"
          target="_blank"
          (click)="
            analyticService.readDoc(
              'Не являюсь близким родственником иностранного должностного лица'
            )
          "
          >иностранного должностного лица</a
        ></span
      >
      <span
        >Не занимаю
        <a
          routerLink="/agreements"
          target="_blank"
          (click)="
            analyticService.readDoc(
              'Не занимаю государственную должность в Российской Федерации'
            )
          "
          >государственную должность</a
        >
        в Российской Федерации</span
      >
      <span
        >Беру заём для себя (<a
          routerLink="/agreements"
          target="_blank"
          (click)="
            analyticService.readDoc(
              'Беру заём для себя (выгодоприобретатель отсутствует'
            )
          "
          >выгодоприобретатель</a
        >
        отсутствует)</span
      >
      <span
        >Прохожу регистрацию по собственному желанию (<a
          routerLink="/agreements"
          target="_blank"
          (click)="
            analyticService.readDoc(
              'Прохожу регистрацию по собственному желанию (бенефициарный владелец отсутствует)'
            )
          "
          >бенефициарный владелец</a
        >
        отсутствует)</span
      >
    </div>
  </div>
</div>
